import React, { useEffect, useState } from "react";
import {
  LocalizationProvider,
  DatePicker,
  PickersDay,
  DatePickerToolbar,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ja from "date-fns/locale/ja";
import { isSaturday, isSunday } from "date-fns";

import { TextField } from "@mui/material";
import { useRecoilState } from "recoil";
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const getEndOfMonth = (date) => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};
const getStartOfMonth = (date) => {
  return new Date(date.getFullYear(), date.getMonth() - 0, 1);
};

const MonthPicker = (props) => {
  // Recoil state を使用してグローバルステートを管理
  const { setFromdate, setTodate, fromDate, toDate } = props;
  const theme = useTheme();
  // 768px以下の画面幅でtrueを返す
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [currentDate, setCurrentDate] = useState(fromDate);

  const handleMonthChange = (newValue) => {
    setCurrentDate(newValue);
    const startDate = getStartOfMonth(newValue);
    const endDate = getEndOfMonth(newValue);

    //props;
    setFromdate(startDate);
    setTodate(endDate);
    //setSelectedDate(newValue); // Recoil state を更新
  };

  // テーマのカスタマイズ
  const themeForDatePicker = createTheme({
    palette: {
      primary: {
        main: "#1A4588", // ここで好きな色を設定できます
      },
    },
    components: {
      // DatePickerの選択された日のスタイルをオーバーライド
      MuiPickersDay: {
        styleOverrides: {
          daySelected: {
            backgroundColor: "#1A4588", // primary.mainと同じ色
            "&:hover": {
              backgroundColor: "##1A4588", // より暗い色にする
            },
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={themeForDatePicker}>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={ja}
        dateFormats={{ monthAndYear: "yyyy年 MM月" }}
      >
        <div>
          <div>
            <DatePicker
              label="対象年月"
              views={["year", "month"]}
              openTo="year"
              value={currentDate}
              onChange={handleMonthChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      // ここにカスタムスタイルを追加
                      color: theme.palette.primary.main,
                    },
                  }}
                />
              )}
              inputFormat="yyyy年MM月"
              format="yyyy年MM月"
              slots={{
                toolbar: CustomDatePickerToolbar,
              }}
              sx={{
                width: isMobile ? "120px" : "150px",
                marginTop: "10px",
                "& input": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  paddingLeft: "14px",
                  height: "38px",
                  fontSize: "14px",
                  color: theme.palette.foreColor.main,
                },
                "& label": {
                  fontSize: "12px",
                  color: theme.palette.foreColor.main,
                },
              }}
            />
          </div>
        </div>
      </LocalizationProvider>
    </ThemeProvider>
  );
};
const CustomDatePickerToolbar = (props) => {
  const { date, changeYear, changeMonth, isLandscape, onChange, ...other } =
    props;
  return (
    <DatePickerToolbar
      toolbarFormat="yyyy年MM月" // スマホ用の画面で出るツールバーの順番を整備
      isLandscape={isLandscape}
      onChange={onChange}
      value={date}
      view={date}
      {...other}
    />
  );
};

export default MonthPicker;
